import React from 'react';

import { useParams } from 'react-router-dom';

import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';

import { RibbonButton } from 'common/components';
import gridSelector from 'common/components/grid-view/controllers/selectors';

import { useGetProductFullView, useGlobalModal } from 'hooks';

import messages from 'i18n/messages/home';

import { isEmpty } from 'lodash';

const AssignCategoryToProduct = ({ isProductDetail }) => {
  const { id: productId } = useParams();

  const intl = useIntl();
  const selectedItemDetailList = useSelector(
    gridSelector.makeSelectDetailCurrentITemsSelection()
  );

  const { productFull } = useGetProductFullView({
    productId,
  });

  const { openModal, MODAL_NAMES } = useGlobalModal();

  const someIsProductOverlay =
    selectedItemDetailList?.length > 0 &&
    selectedItemDetailList.some(
      (productITem) => productITem.isOverlayProduct === true
    );

  const onClickButton = () => {
    openAssignCategoryToProductModal();
  };

  const openAssignCategoryToProductModal = () => {
    openModal(MODAL_NAMES.ASSIGN_CATEGORY_TO_PRODUCT);
  };

  const disabled = isProductDetail
    ? isEmpty(productFull)
    : selectedItemDetailList.length === 0 || someIsProductOverlay;

  return (
    <>
      <RibbonButton
        size={'small'}
        className='button-item-dropdown'
        icon={<i className='fa-solid fa-tags'></i>}
        label={intl.formatMessage(messages.assignCategoryToProductTitle)}
        onClick={onClickButton}
        disabled={disabled}
      />
    </>
  );
};

export default AssignCategoryToProduct;
